import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  WebexDialPlanFieldConfig,
  WebexFieldConfig,
  WebexFieldConfigV2,
} from '../../../../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable()
export class WebexCallingFieldConfigResource {
  private http = inject(HttpClient);

  getDialPlanFieldConfigs(): Observable<WebexDialPlanFieldConfig[]> {
    return this.http.get<WebexDialPlanFieldConfig[]>('/services/cisco/field-configs/webex-calling-dial-plan');
  }

  getFieldConfigs(email: string): Observable<WebexFieldConfig> {
    return this.http.get<WebexFieldConfig>(`/services/cisco/field-configs/webex-calling?email=${email}`);
  }

  getFieldConfigsV2(siteId: number): Observable<WebexFieldConfigV2> {
    return this.http.get<WebexFieldConfigV2>(`/services/cisco/field-configs/webex-calling/v2?siteId=${siteId}`);
  }
}
